import React from "react";
import TimeLine from "./TimeLine";
import DayLine from "./DayLine";
import { ScheduleConfig } from "../types/schedule";

interface TimeGridViewProps {
  minClassHour: number;
  maxClassHour: number;
  containerHeight: number;
  timeLineDataArray: number[];
  dayLineDataArray: { label: string }[];
  containerWidth: number;
  config: ScheduleConfig;
}

const TimeGridView: React.FC<TimeGridViewProps> = ({
  minClassHour,
  containerHeight,
  timeLineDataArray,
  dayLineDataArray,
  containerWidth,
  config,
}) => {
  const { leftMarginPx, rightMarginPx, dayColumns, hourHeight } = config;
  const dayColumnWidthPx =
    containerWidth > 0
      ? (containerWidth - leftMarginPx - rightMarginPx) / dayColumns
      : 0;

  return (
    <>
      {/* 시간선 렌더링 */}
      {timeLineDataArray.map((hour) => (
        <TimeLine
          key={`timeLine-${hour}`}
          top={(hour - minClassHour) * hourHeight}
          hour={hour}
          config={config}
        />
      ))}

      {/* 요일선 렌더링 */}
      {dayLineDataArray.map((dayData, i) => {
        const leftPx =
          containerWidth > 0 ? leftMarginPx + dayColumnWidthPx * i : 0;
        const nextLeftPx =
          containerWidth > 0 ? leftMarginPx + dayColumnWidthPx * (i + 1) : 0;
        const labelLeftPx = (leftPx + nextLeftPx) / 2;
        return (
          <DayLine
            key={`day-${i}`}
            left={leftPx}
            labelLeft={labelLeftPx}
            label={dayData.label}
            top={0}
            height={(timeLineDataArray.length - 1) * hourHeight}
          />
        );
      })}
    </>
  );
};

export default TimeGridView;
